<template>
  <div class="w-full">
    <div class="customer rounded px-2 pt-2 pb-8 mb-6">
      <el-row :gutter="20">
        <el-col :span="24" class="mb-6">
          <el-button icon="el-icon-back" size="small"
                     @click="$router.push('/ecommerce/customers')">Back to list</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                     @click="onDeleteCustomer(customer.id)">Delete</el-button>
          <el-button type="warning" icon="el-icon-edit" size="small" class="float-right"
                     @click="onEditCustomer(customer.id)">Edit</el-button>
          <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                     @click="$router.push('/ecommerce/customers/new')">New</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Name:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">{{ customer.first_name }} {{ customer.last_name }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Email:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">{{ customer.email }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Phone:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">{{ customer.phone }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Gender:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">{{ customer.gender }}</div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Date of Birth:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">
          <span v-if="customer.dob">{{customer.dob | moment("MMMM Do, YYYY") }}</span>
        </div></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Subscribed to newsletter:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <template v-if="customer.newsletter === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Verified:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <template v-if="customer.verified === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Suspended:</div></el-col>
        <el-col :span="14">
          <div class="px-4 mb-6">
            <template v-if="customer.suspended === true"><el-tag size="small" type="success">Yes</el-tag></template>
            <template v-else><el-tag size="small" type="danger">No</el-tag></template>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="10"><div class="px-4 mb-6 hd">Signed up:</div></el-col>
        <el-col :span="14"><div class="px-4 mb-6">{{ customer.created_at | moment("from") }}</div></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CustomerDetails',
  computed: {
    customer() {
      return this.$store.state.CustomerModule.customer;
    },
  },
  methods: {
    onEditCustomer(id) {
      this.$router.push(`/ecommerce/customers/${id}/edit`);
    },
    onDeleteCustomer(customerId) {
      this.$confirm('Are you sure you want to delete this customer?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('CustomerModule/deleteCustomer', { customerId });
          this.$notify.success({
            title: 'Success',
            message: 'Customer has been deleted.',
          });
          await this.$router.push('/customers');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('CustomerModule/getCustomer', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>
  .customer {
    font-size: 15px;
  }
  .hd {font-weight: 500;}
</style>
